import * as core from '../../../../../../../core'

import { query } from './change-impacts-by-epic-and-functional-area.query'

export const RESOURCE = {
  payload: {
    alias: 'change.impacts.by.epic.and.functional.area',
    description: 'Chart view of change impacts by epic and functional area',
    name: 'Change Impacts by Epic and Functional Area',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
